import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  messageDeleteAction,
  messageListAction,
  messageMarkAsReadAction,
  newMessageAction,
  NewMessageSuccessPayload,
} from "./messageActions";
import * as messageServices from "./messageServices";
import { fetchMessageListDone, setNewMessage, startFetchingMessageList } from "./messageSlice";

function* getMessageListSaga({ payload }) {
  try {
    yield put(startFetchingMessageList());
    const res = yield call(messageServices.getMessageList, payload);

    yield put(fetchMessageListDone({ ...res }));
  } catch (error) {
    yield put(fetchMessageListDone({ error }));
  }
}

function* getNewMessageSaga() {
  try {
    const results: NewMessageSuccessPayload = yield call(messageServices.getNewMessage);

    yield put(setNewMessage({ ...results }));
  } catch (error) {
    yield put(setNewMessage({ error }));
  }
}

function* deleteMessageSaga(action: ReturnType<typeof messageDeleteAction>) {
  try {
    yield call(messageServices.deleteMessage, action.payload.id);
    const res = yield call(messageServices.getMessageList, action.payload.params);

    yield put(fetchMessageListDone({ ...res }));
  } catch (error) {
    yield put(fetchMessageListDone({ error }));
  }
}

function* markMessageAsReadSaga(action: ReturnType<typeof messageMarkAsReadAction>) {
  try {
    yield call(messageServices.markMessageAsRead, action.payload.id, action.payload.markReadAs);
    const res = yield call(messageServices.getMessageList, action.payload.params);

    yield put(fetchMessageListDone({ ...res }));
  } catch (error) {
    yield put(fetchMessageListDone({ error }));
  }
}

function* watchNewMessageSaga() {
  yield takeLatest(newMessageAction, getNewMessageSaga);
}

function* watchMessageListSaga() {
  yield takeLatest(messageListAction, getMessageListSaga);
}

function* watchMessageDeleteSaga() {
  yield takeLatest(messageDeleteAction, deleteMessageSaga);
}

function* watchMessageMarkAsReadSaga() {
  yield takeLatest(messageMarkAsReadAction, markMessageAsReadSaga);
}

export default function* () {
  yield all([
    watchNewMessageSaga(),
    watchMessageListSaga(),
    watchMessageDeleteSaga(),
    watchMessageMarkAsReadSaga(),
  ]);
}
